import React, { Component } from 'react';

import './EstrategiaCurtoPrazo.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	estrategia_content
} from '../../settings';

import {
	TabButton,
	TabItem
} from '../../components/';

class EstrategiaCurtoPrazo extends Component {

	constructor() {
		super();

        this.images = images;
        this.estrategia_content = estrategia_content;

        this.baseTabs = [
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        	false,
        ];

        this.state = {
            width: window.innerWidth,
            cardsDiretores: 0,
            lineDiretoresLeft: 0,
            tabsActive: this.baseTabs
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeTab = this.changeTab.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    prevPersonDiretores() {
    	console.log('prev');
    	if (this.state.cardsDiretores > 0) {
    		this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores - 1),
    			cardsDiretores: this.state.cardsDiretores - 1
    		});
    	}
    }

    nextPersonDiretores() {
    	console.log('next');
    	if (this.state.cardsDiretores < (this.governanca_content.comite_executivo.length - 2)) {
	    	this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores + 1),
    			cardsDiretores: this.state.cardsDiretores + 1
    		});
	    }
    }

    changeTab(id) {
    	var newTabsActive;
    	if (this.state.tabsActive[id] == true) {
			this.baseTabs.fill(false);
	    	newTabsActive = this.baseTabs;
	    	newTabsActive[id] = false;
    	} else {
			this.baseTabs.fill(false);
	    	newTabsActive = this.baseTabs;
	    	newTabsActive[id] = true;
    	}

    	this.setState({
    		tabsActive: newTabsActive
    	});
    }

    closeTab(id) {
    	
    	this.setState({
    		tabsActive: newTabsActive
    	});
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('6.2 Plano de ação 2019');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'curto-prazo'
		];

		const tabButtons = [];
		for (let i = 0; i < this.estrategia_content.curto_prazo_tabs.length; i++) {
			let forItem = this.estrategia_content.curto_prazo_tabs[i];
			tabButtons.push(
				<TabButton
					onClick={ this.changeTab.bind(null, i) }
					key={ i }
					active={ this.state.tabsActive[i] }
					id={ forItem.id }
					color={ forItem.color }
					title={ forItem.title } />
			);
		}

		const tabs = [];
		for (let i = 0; i < this.estrategia_content.curto_prazo_tabs.length; i++) {
			let forItem = this.estrategia_content.curto_prazo_tabs[i];
			tabs.push(
				<TabItem
					key={ i }
					active={ this.state.tabsActive[i] }
					id={ forItem.id }
					color={ forItem.color }
					content={ forItem.content } />
			);
		}

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>6.2 Plano de ação 2019 - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>6.2</span> Plano de ação 2019</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Estratégia</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h3 className="first_title">
					        				<span className="gri_label"><text>GRI 102-15</text></span>
					        			</h3>
				        				<p>
					        				O plano de ação de 2019 terá os mesmos focos de atuação trabalhados em 2018: mercado de capitais; poupança de longo prazo; ética e regulação; inovação; e tributação.
										</p>

				        				<h3 className="titled_view__title">Veja o detalhamento de cada tema:</h3>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content tabs__view row">
			        		<div className="container">

			        			<div className="tabs_component">
				        			<div className="tabs__header">
				        				{ tabButtons }
				        			</div>
				        			<div className="tabs__content">
				        				{ tabs }
				        			</div>
			        			</div>

		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { EstrategiaCurtoPrazo };
